<template>
  <main class="gain-main">
    <!-- Background with coffee bean on the right (desktop) -->
    <div class="background-container background-desktop">
      <img 
        src="@/assets/img/KV_Fond_Dotation.jpg" 
        alt="Background" 
        class="background-image"
      />
    </div>
    
    <!-- Background with coffee bean centered (mobile) -->
    <div class="background-container background-mobile">
      <img 
        src="@/assets/img/KV_Fond.jpg" 
        alt="Background" 
        class="background-image"
      />
    </div>

    <!-- Main container -->
    <div class="container">
      <div class="content-wrapper">
        <!-- Left column: Text content centered -->
        <div class="left-column">
          <div class="text-content">
            <h1 class="title">BRAVO !</h1>
            
            <p class="subtitle">VOUS AVEZ GAGNÉ</p>

            <p class="prize-text">
              <strong>UNE GRANDE TASSE CARTE NOIRE !</strong>
            </p>

            <!-- Prize image -->
            <div class="prize-display">
              <img src="@/assets/img/Tasse_1.png" alt="Grande tasse Carte Noire" class="prize-image" />
            </div>

            <p class="email-notice">
              <strong>Un email vient de vous être envoyé !</strong><br/>
              Pensez à vérifier votre dossier «&nbsp;courrier indésirable&nbsp;»
            </p>
          </div>
        </div>

        <!-- Right column: Space for coffee bean background -->
        <div class="right-column"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Gain2View",
  mounted() {
    // Mode test : désactiver la vérification si ?test=true
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("test") === "true") {
      return;
    }

    // Vérifier que le résultat du jeu existe et correspond à un gain tasse
    const gameResult = window.__gameResult;

    if (!gameResult || gameResult.status !== "GAGNE" || gameResult.lot !== "tasse") {
      window.location.href = "/";
      return;
    }

    // Nettoyer la variable après utilisation
    delete window.__gameResult;
  },
};
</script>

<style scoped>
.gain-main {
  background-color: #000;
  color: white;
  position: relative;
  min-height: calc(100vh - 150px - 60px);
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 5vw, 60px);
  position: relative;
  z-index: 10;
  width: 100%;
  flex: 1;
}

.background-container {
  position: absolute;
  top: 0;
  left: 0%;
  bottom: 5%;
  width: 100%;
  pointer-events: none;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: all 0.3s ease;
}

.background-desktop {
  display: flex;
}

.background-mobile {
  display: none;
}

.background-image {
  width: auto;
  height: 110%;
  max-height: none;
  object-fit: cover;
  object-position: center;
  transition: all 0.3s ease;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: calc(100vh - 150px - 60px);
  align-items: center;
  transition: all 0.3s ease;
}

.left-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: clamp(20px, 4vw, 40px) 0;
}

.text-content {
  text-align: center;
}

.title {
  font-family: var(--font-primary);
  font-size: 84px;
  font-weight: 900;
  line-height: 1.1;
  margin: 0 0 clamp(10px, 2vw, 20px) 0;
  color: white;
  text-transform: uppercase;
}

.subtitle {
  font-family: var(--font-primary);
  font-weight: 700;
  font-size: 34px;
  color: white;
  line-height: 1.1;
  margin: 0 0 10px 0;
  text-transform: uppercase;
}

.prize-text {
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 34px;
  color: white;
  line-height: 1.1;
  margin: 0 0 clamp(15px, 3vw, 30px) 0;
}

.prize-text strong {
  font-weight: 700;
}

.prize-display {
  margin: clamp(15px, 2vw, 20px) 0 clamp(20px, 4vw, 40px) 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.prize-image {
  height: clamp(120px, 18vw, 180px);
  object-fit: contain;
  display: block;
}

.email-notice {
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 24px;
  color: white;
  line-height: 1.1;
  margin: 0;
}

.email-notice strong {
  font-weight: 700;
}

.right-column {
  /* Space for coffee bean background */
}

/* Large screens (2K+) - limit background size */
@media (min-width: 1920px) {
  .background-image {
    height: auto;
    max-height: 700px;
  }
}

/* Tablet breakpoint */
@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1.2fr 0.8fr;
  }

  .background-container {
    width: 50%;
  }
}

/* Mobile/Tablet transition */
@media (max-width: 768px) {
  .gain-main {
    min-height: auto;
  }

  .content-wrapper {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .background-desktop {
    display: none;
  }

  .background-mobile {
    display: flex;
    position: relative;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    min-height: 320px;
    top: auto;
    right: auto;
    bottom: auto;
    order: 2;
    margin-top: 0;
    background-color: #000;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .background-mobile .background-image {
    width: 160%;
    max-width: none;
    height: auto;
    min-height: 380px;
    object-fit: cover;
    object-position: center;
    margin-top: -40px;
  }

  .left-column {
    order: 1;
    padding: 30px 0 0 0;
  }

  .right-column {
    display: none;
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .background-mobile {
    min-height: 320px;
  }

  .background-mobile .background-image {
    width: 170%;
    min-height: 320px;
  }

  .prize-image {
    height: 120px;
  }
}
</style>
